<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
<mat-dialog-content>
    <p>
        {{parentData.message}}
    </p>

  <!-- <div
    class="add_crt"
    style="display: flex; gap: 20px; margin-bottom: 20px; margin-top: 15px"
  >
    <div class="try">
      <mat-checkbox [(ngModel)]="refund"></mat-checkbox>
      <label
        style="margin-left: 10px; position: relative; top: -3px"
        for="testing1"
        class="check-label"
        >Transfer paid amount to wallet.</label
      >
    </div>
  </div> -->
</mat-dialog-content>
  
<mat-dialog-actions align="end">
  <div class="flex_anand">
  <button mat-button mat-dialog-close class="btn-no-outline">{{parentData.cancelbtn}}</button>
  <button class="bgn" mat-flat-button color="accent" (click)="transferToWallet()">
    {{parentData.okbtn2}}
  </button>
  <button class="btnrgn" mat-flat-button color="accent" (click)="refundOnline()">
    {{parentData.okbtn}}
  </button>
  </div>
</mat-dialog-actions>

  